/**
 * Shared Excel column default literals used by product sheet definitions.
 * Prefer these over raw true / false / "" so defaults stay consistent.
 */

/** Empty-string default for optional Excel columns. */
export enum ExcelEmptyDefault {
  Empty = "",
}

/**
 * String boolean defaults (Spa / Golf Visual One templates often expect "True"/"False").
 */
export enum ExcelBooleanString {
  True = "True",
  False = "False",
}

/**
 * Native boolean defaults (Versa and some Golf/Spa columns).
 * Const object — TypeScript does not support boolean enum members.
 */
export const ExcelBoolean = {
  True: true,
  False: false,
} as const;
